//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import KirbyLink from './kirbylink.vue'
export default {
    name: "featurecenteredgrid",
    props:{
      content: Object
    },
    components:{
      KirbyLink
    }
}
